import { NgModule } from '@angular/core';
import { DockComponent } from './dock.component';
import { CommonModule } from '@angular/common';

@NgModule({
    declarations: [
        DockComponent
    ],
    imports: [
        CommonModule
    ],
    exports: [
        DockComponent
    ]
})
export class NcDockModule { }